const OUTCOME_TYPE = "CSLO";
const CONTEXT_TYPE = "course";
const INGRESS_POINT = "CSLO_FILE_UPLOAD";
export const OBJECT_TYPE = "outcome";

export const enrichBulkCLOs = (termId, autoApprove) => {
  return {
    object_type: OBJECT_TYPE,
    outcome_type: OUTCOME_TYPE,
    context_type: CONTEXT_TYPE,
    ingress_point: INGRESS_POINT,
    effective_term_id: termId,
    archive_term_id: termId,
    auto_approve: autoApprove,
  };
};

export const enrichCLOs = (courseId, offeringId, subject) => {
  return {
    object_type: OBJECT_TYPE,
    academic_subject: subject,
    context_id: courseId,
    offering_id: offeringId,
    outcome_type: OUTCOME_TYPE,
    context_type: CONTEXT_TYPE,
    ingress_point: INGRESS_POINT,
  };
};

export const sortCourses = (courses) => {
  return courses.sort((a, b) => {
    // Extract the numerical part from the strings (e.g. CS101 -> 101)
    const numA = parseInt(a.code.match(/\d+/) ? a.code.match(/\d+/)[0] : 0, 10);
    const numB = parseInt(b.code.match(/\d+/) ? b.code.match(/\d+/)[0] : 0, 10);

    // Extract the prefix, compare alphabetically (e.g. CS101 -> "CS")
    const prefixA = a.code.match(/^\D+/) ? a.code.match(/^\D+/)[0] : "";
    const prefixB = b.code.match(/^\D+/) ? b.code.match(/^\D+/)[0] : "";

    // Extract the suffix (any letter after the number, e.g. CS101A -> "A")
    let suffixA = a.code.match(/\d+(\D+)$/);
    let suffixB = b.code.match(/\d+(\D+)$/);
    suffixA = suffixA ? suffixA[1] : ""; // If there's no suffix, set it to empty string
    suffixB = suffixB ? suffixB[1] : ""; // If there's no suffix, set it to empty string

    // If prefixes are the same, sort by the numeric part
    if (prefixA === prefixB) {
      if (numA === numB) {
        // If both prefix and number are the same, compare by suffix (if present)
        return suffixA.localeCompare(suffixB);
      } else {
        // Sort by the numeric part if prefixes are the same
        return numA - numB;
      }
    } else {
      // Otherwise, sort alphabetically by the prefix
      return prefixA.localeCompare(prefixB);
    }
  });
};
